import client from '/src/services/client.js';

export default {
    getAgentsPerformance: (filters) => client.get('analytics/agents-performance', filters || {}),
};
